export const TENANT_NAME = 'TENANT_NAME';
